import React from 'react';
import { clsx } from 'clsx';

interface ProgressBarProps {
  /** 0..100 */
  value: number;
  variant?: 'default' | 'success' | 'error' | 'muted';
  showLabel?: boolean;
  className?: string;
}

const BAR = {
  default: 'bg-emerald-500',
  success: 'bg-green-600',
  error: 'bg-red-500',
  muted: 'bg-slate-400',
};

/** Barra de progresso horizontal. */
export const ProgressBar: React.FC<ProgressBarProps> = ({ value, variant = 'default', showLabel = false, className }) => {
  const pct = Math.max(0, Math.min(100, Number.isFinite(value) ? value : 0));
  return (
    <div className={clsx('flex items-center gap-2', className)}>
      <div
        className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(pct)}
      >
        <div className={clsx('h-full rounded-full transition-all duration-200', BAR[variant])} style={{ width: `${pct}%` }} />
      </div>
      {showLabel && <span className="text-xs text-slate-500 w-10 text-right tabular-nums">{Math.round(pct)}%</span>}
    </div>
  );
};

export default ProgressBar;
